import { useEffect } from 'react';

import { useTracking } from 'src/hooks/useTracking';

import { PAGE_JOB_LIST_DISPLAYED } from '../../App/constants/tracking';

export const PageLoadTracker = () => {
  const { trackingData, trackPageView } = useTracking();
  const { userId } = trackingData;

  useEffect(() => {
    if (userId) {
      trackPageView(PAGE_JOB_LIST_DISPLAYED);
    }
  }, [userId, trackPageView]);

  return null;
};
